import React, { useEffect, useState } from 'react';
import { Avatar, Card, Col, Row, Image, Modal, Button } from 'antd';
import { UserOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  getOrderServiceByOrderNo,
  updateStatusToAccepted,
  updateStatusToRejected,
  categoryOrderService,
  ORDER_SERVICE_STATUS,
  sendOwnerNotiMessage,
} from '../../reducers/actions/orderService';

interface IProps {
  id: string;
}

const CONSTRUCTION = {
  APPROVE: 'approve',
  REJECT: 'reject',
};

const OrderServiceDetail: React.FC<IProps> = ({ id }) => {
  const { orderServiceDetail } = useSelector((state: any) => state);
  const dispatch = useDispatch();

  useEffect(() => {
    if (orderServiceDetail.status === ORDER_SERVICE_STATUS.CREATED) {
      setShouldPay(true);
    } else {
      setShouldPay(false);
    }
  }, [orderServiceDetail]);

  useEffect(() => {
    getOrderServiceByOrderNo(id).then((data) => {
      dispatch(data);
    });
  }, [id]);

  const [shouldPay, setShouldPay] = useState(true);

  const onConfirmOK = () => {
    updateStatusToAccepted(id)
      .then((data) => {
        getOrderServiceByOrderNo(id).then((data) => {
          dispatch(data);
          setShouldPay(false);
        });
        return sendOwnerNotiMessage(
          CONSTRUCTION.APPROVE,
          orderServiceDetail?.user?._id
        );
      })
      .then(() => {
        window.location.reload();
      });
  };

  const onConfirmCancel = () => {
    console.log('on Cancel');
  };

  const onClickCancel = () => {
    updateStatusToRejected(id)
      .then((data) => {
        getOrderServiceByOrderNo(id).then((data) => {
          dispatch(data);
          setShouldPay(false);
        });
        return sendOwnerNotiMessage(
          CONSTRUCTION.REJECT,
          orderServiceDetail?.user?._id
        );
      })
      .then(() => {
        window.location.reload();
      });
  };

  const onClickOK = () => {
    Modal.confirm({
      title: '',
      icon: '',
      content: (
        <div style={{ textAlign: 'start' }}>
          <CheckCircleOutlined
            style={{
              color: 'green',
              fontSize: '40px',
              paddingBottom: '16px',
            }}
          />
          <h2>ยืนยันรับงานนี้</h2>
          <span>
            เมื่อท่านกด ”ยืนยัน”
            จะถือว่ารับงานนี้แล้วโดยไม่สามารถยกเลิกและ
            ไม่สามารถแก้ไขข้อมูลของท่านได้จนกว่าจะจบงาน
          </span>
        </div>
      ),
      okText: 'ยืนยัน',
      cancelText: 'ยกเลิก',
      onOk: onConfirmOK,
      onCancel: onConfirmCancel,
    });
  };

  return (
    <>
      <Card
        title={
          <Row justify="start" gutter={[32, 32]}>
            <Col>
              <Avatar
                size={{
                  xs: 64,
                  sm: 64,
                  md: 64,
                  lg: 64,
                  xl: 80,
                  xxl: 100,
                }}
                icon={<UserOutlined />}
              />
            </Col>
            <Col>
              <h3 style={{ fontSize: '24px' }}>
                {orderServiceDetail.status !==
                ORDER_SERVICE_STATUS.CREATED
                  ? orderServiceDetail?.customer?.name
                  : 'ผู้ติดต่อ'}
              </h3>
              <span>
                {orderServiceDetail.status !==
                ORDER_SERVICE_STATUS.CREATED
                  ? orderServiceDetail?.customer?.phone
                  : '-'}
              </span>
            </Col>
          </Row>
        }
        bordered={false}
        style={{ width: '100%' }}
      >
        <div>
          <div
            style={{
              fontSize: '26px',
              fontWeight: 'bold',
              color: '#045DE9',
            }}
          >
            #{orderServiceDetail.orderNo}{' '}
            <span style={{ color: 'black' }}>
              {categoryOrderService(orderServiceDetail.category)}
            </span>
          </div>
          <div>
            <Row
              justify="start"
              gutter={[8, 8]}
              style={{
                padding: '8px 0',
                fontSize: '16px',
              }}
            >
              <Col style={{ color: '#B0B1B1' }} span={5}>
                ชื่อ - สกุลผู้ติดต่อ
              </Col>
              <Col>
                {orderServiceDetail.status !==
                ORDER_SERVICE_STATUS.CREATED
                  ? orderServiceDetail?.customer?.name
                  : 'ผู้ติดต่อ'}
              </Col>
            </Row>
            <Row
              justify="start"
              gutter={[8, 8]}
              style={{
                padding: '8px 0',
                fontSize: '16px',
              }}
            >
              <Col style={{ color: '#B0B1B1' }} span={5}>
                เบอรโทรศัพท์
              </Col>
              <Col>
                {orderServiceDetail.status !==
                ORDER_SERVICE_STATUS.CREATED
                  ? orderServiceDetail?.customer?.phone
                  : '-'}
              </Col>
            </Row>
            <Row
              justify="start"
              gutter={[8, 8]}
              style={{
                padding: '8px 0',
                fontSize: '16px',
              }}
            >
              <Col style={{ color: '#B0B1B1' }} span={5}>
                ที่อยู่
              </Col>
              <Col>
                {orderServiceDetail.customer?.address}{' '}
                {`แขวง${orderServiceDetail.customer?.subDistrictName}`}{' '}
                {`เขต${orderServiceDetail.customer?.districtName}`}{' '}
                {`จังหวัด${orderServiceDetail.customer?.provinceName}`}{' '}
                {orderServiceDetail.customer?.postCode}
              </Col>
            </Row>
            <Row
              justify="start"
              gutter={[8, 8]}
              style={{
                padding: '8px 0',
                fontSize: '16px',
              }}
            >
              <Col style={{ color: '#B0B1B1' }} span={5}>
                รายละเอียด(เพิ่มเติม)
              </Col>
              <Col>{orderServiceDetail.description}</Col>
            </Row>
          </div>
          <br />
          <div>
            <h2>รูปหน้างาน/แบบแปลน</h2>
            <div>
              <Image.PreviewGroup>
                {orderServiceDetail.images?.map(
                  (image: any, index: number) => {
                    return (
                      <Image
                        key={index}
                        width={100}
                        height={100}
                        style={{ objectFit: 'cover', padding: '4px' }}
                        src={image.image_url}
                      />
                    );
                  }
                )}
              </Image.PreviewGroup>
            </div>
          </div>
          <br />
          <br />
          {shouldPay ? (
            <Row
              justify="center"
              gutter={[16, 16]}
              style={{ marginTop: '30px' }}
            >
              <Col span={12}>
                <Button block size="large" onClick={onClickCancel}>
                  ไม่รับงานนี้
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  block
                  size="large"
                  type="primary"
                  onClick={onClickOK}
                >
                  รับงานนี้
                </Button>
              </Col>
            </Row>
          ) : (
            <></>
          )}
        </div>
      </Card>
    </>
  );
};

export default OrderServiceDetail;
